import { render, staticRenderFns } from "./SettingsPannel.vue?vue&type=template&id=154c921c"
import script from "./SettingsPannel.vue?vue&type=script&lang=js"
export * from "./SettingsPannel.vue?vue&type=script&lang=js"
import style0 from "./SettingsPannel.vue?vue&type=style&index=0&id=154c921c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports